
export enum AppRunningMode {
    BROWSER = '_BW_',
    MOBILE = '_MO_',
    PWA = '_EB_'
}